var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactRequest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n\n      .cls-1 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pradhip icn 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.13,
    y1: 16.18,
    x2: 18.13,
    y2: 20.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.81,
    y1: 18.5,
    x2: 20.45,
    y2: 18.5
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.41,
    cy: 6,
    r: 4.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.8,22.15H2.45V22c0-3.93,1.84-7.57,4.72-8.85a10.78,10.78,0,0,1,7.12-.42"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.91,
    cy: 18.45,
    r: 4.59
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactRequest);
export default __webpack_public_path__ + "static/media/contact_request.74714af4ce29771c9ffa1c26fdaa8327.svg";
export { ForwardRef as ReactComponent };